import { apiClientAuth } from "../http/httpClient";


export function MaintenanceApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    return {
        
       /**
        * GET /api/maintenances
        * @desc    Retrieve all maintenance requests
        * @access  Private (Admin)
        * @returns {Object} Array of all maintenance requests with user information sorted by createdAt DESC
        */
        findAll: () => https.get(`/api/maintenances`),

       /**
        * GET /api/maintenances/count/status
        * @desc    Get total count of maintenances by status
        * @access  Private (Admin)
        * @returns {Object} Object with count for each status:
        *   - pending: number of pending requests
        *   - done: number of completed requests
        *   - canceled: number of canceled requests
        *   - total: total count of all requests
        */
        getCount: () => https.get(`/api/maintenances/count/status`),

       /**
        * PUT /api/maintenances/:id/status
        * @desc    Update maintenance request status and set admin email
        * @access  Private (Admin)
        * @param   {integer} id - Maintenance request ID - required
        * @param   {string} status - New status (pending, done, canceled) - required
        * @returns {Object} Updated maintenance request with new status and admin
        */
        update: (id, status) => https.put(`/api/maintenances/${id}/status`, status),

        /**
        * PUT /api/maintenances/:id
        * @desc    Update maintenance request status and set admin email
        * @access  Private (Admin)
        * @param   {integer} id - Maintenance request ID - required
        * @param   {string} status - New status (pending, done, canceled) - required
        * @param   {string} price  - required
        * @returns {Object} Updated maintenance request with new status and admin
        */
        updateOne: (id, data) => https.put(`/api/maintenances/${id}`, data),

        
       /**
        * GET /api/maintenances/:id
        * @desc    Retrieve single maintenance request by ID
        * @access  Private (Admin)
        * @param   {integer} id - Maintenance request ID - required
        * @returns {Object} Maintenance request data with user information
        */
        findOne: (id) => https.get(`/api/maintenances/${id}`),

      };
}

